import { PORTFOLIO_PIDS_URL } from "../config/deforestation";

// JSON file is keyed by demo cluster name → cadastrePid[]. We only need
// the flat set of pids at runtime, the cluster grouping isn't surfaced
// in the UI.
type PortfolioJson = Record<string, string[]>;

let pids: string[] | null = null;
let pidsPromise: Promise<string[]> | null = null;

export function ensurePortfolioPids(): Promise<string[]> {
  if (pids) return Promise.resolve(pids);
  if (pidsPromise) return pidsPromise;
  pidsPromise = fetch(PORTFOLIO_PIDS_URL)
    .then((res) => {
      if (!res.ok) {
        throw new Error(
          `portfolio pids fetch failed: ${res.status} ${res.statusText}`,
        );
      }
      return res.json() as Promise<PortfolioJson>;
    })
    .then((data) => {
      const flat = Array.from(new Set(Object.values(data).flat()));
      pids = flat;
      return flat;
    })
    .catch((err) => {
      console.error("[vegetation-change] portfolio pids load failed:", err);
      pids = [];
      return [] as string[];
    });
  return pidsPromise;
}

export function getPortfolioPids(): string[] {
  return pids ?? [];
}
